import React from "react";

import Section from "./Section";
// 🔹 Main Component: HTML_Basic
export default function HTML_Basic() {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">🌐 HTML Basic — Getting Started</h1>

      {/* Intro */}
      <div
        className="Key_point_container"
        style={{ backgroundColor: "#fef9c3" }}
      >
        <p>
          HTML (HyperText Markup Language) is the foundation of all web pages.
          It describes the <b>structure</b> of a web page using elements like
          headings, paragraphs, images, and links.
        </p>
      </div>

      {/* Section 1: Basic HTML Structure */}
      <Section
        title="1️⃣ Basic HTML Document"
        html={`<!DOCTYPE html>
<html>
<head>
  <title>My First HTML Page</title>
</head>
<body>
  <h1>Hello World!</h1>
  <p>This is my first HTML page.</p>
</body>
</html>`}
        description="Every HTML document starts with <!DOCTYPE html> and contains <html>, <head>, and <body> sections."
      />

      {/* Section 2: Headings */}
      <Section
        title="2️⃣ Headings"
        html={`<h1>This is a Heading 1</h1>
<h2>This is a Heading 2</h2>
<h3>This is a Heading 3</h3>`}
        description="HTML offers six levels of headings (h1 to h6). Use them to define page structure and importance."
      />

      {/* Section 3: Paragraphs and Line Breaks */}
      <Section
        title="3️⃣ Paragraphs & Line Breaks"
        html={`<p>This is a paragraph.</p>
<p>This is another paragraph.</p>
<p>Line one.<br/>Line two (after a line break).</p>`}
        description="<p> creates paragraphs. <br/> forces a line break."
      />

      {/* Section 4: Links */}
      <Section
        title="4️⃣ Hyperlinks"
        html={`<a href="https://www.google.com" target="_blank">Visit Google</a>`}
        description="Use <a> to create links. The href attribute defines the destination URL."
      />

      {/* Section 5: Images */}
      <Section
        title="5️⃣ Images"
        html={`<img src="https://via.placeholder.com/150" alt="Sample Image" />`}
        description="Use <img> to display images. Always include an alt attribute for accessibility."
      />

      {/* Section 6: Lists */}
      <Section
        title="6️⃣ Lists"
        html={`<h3>Ordered List:</h3>
<ol>
  <li>HTML</li>
  <li>CSS</li>
  <li>JavaScript</li>
</ol>

<h3>Unordered List:</h3>
<ul>
  <li>Apple</li>
  <li>Banana</li>
  <li>Cherry</li>
</ul>`}
        description="HTML supports ordered (<ol>) and unordered (<ul>) lists."
      />

      {/* Summary */}
      <div
        style={{
          background: "linear-gradient(135deg, #d1fae5, #a7f3d0)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2 style={{ color: "#065f46" }}>📘 Summary</h2>
        <ul className="tutorial-list-points">
          <li>
            All HTML pages start with <b>&lt;!DOCTYPE html&gt;</b>
          </li>
          <li>
            Headings range from <b>h1</b> (largest) to <b>h6</b> (smallest)
          </li>
          <li>
            Use <b>p</b> for paragraphs and <b>br</b> for line breaks
          </li>
          <li>
            Links are made with <b>a href=""</b>
          </li>
          <li>
            Images use <b>img src="" alt=""</b>
          </li>
          <li>
            Lists can be ordered (<b>ol</b>) or unordered (<b>ul</b>)
          </li>
        </ul>
      </div>
    </div>
  );
}

// 🔹 Reusable Section
